import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { Navigation } from 'app/core/navigation/navigation.types';
import { compactNavigation, defaultNavigation } from 'assets/storage/navigation';
import { cloneDeep } from 'lodash';
import { map, Observable, ReplaySubject, Subject, take, takeUntil, tap } from 'rxjs';
import { UserService } from '../user/user.service';
import { User } from '../user/user.types';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    // private _httpClient = inject(HttpClient);
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    private _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private  _compactNavigation: FuseNavigationItem[] = compactNavigation; 

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(private _userService: UserService)
    {
        
    }

    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

  
    get(): Observable<Navigation>
    {
        return this._userService.user$.pipe(
            // takeUntil(this._unsubscribeAll),
            // se vuoi solo la prima emissione:
            take(1),

            map((user: User) =>
            {
                const compactNavigation = cloneDeep(this._compactNavigation)
                    .filter(item => !item.meta || item.meta.includes(user.role));

                compactNavigation.forEach(compactNavItem =>
                {
                    const defaultNavItem = this._defaultNavigation
                        .find(x => x.id === compactNavItem.id);

                    if (defaultNavItem?.children)
                    {
                        compactNavItem.children = cloneDeep(
                            defaultNavItem.children.filter(
                                x => !x.meta || x.meta.includes(user.role)
                            )
                        );
                    }
                });

                const navigation: Navigation = {
                    compact: compactNavigation,
                    default: cloneDeep(this._defaultNavigation),
                    futuristic : null,
                    horizontal : null
                };

                this._navigation.next(navigation);

                return navigation;
            })
        );
    }
}
